import React from 'react';
import ActionButton from '../ActionButton';
import { useTier, controlHeight } from '../../lib/tiers';
import { UNDO_LABEL, UNDONE_LINE } from '../../lib/transferCardJobs';

// #761, Session 79.22b.6c.3 -- RECORD PRODUCTION'S ANSWER, WITH THE UNDO A RUN
// FOR THE SHELF NEVER HAD. The corrections gate's frame T4, built exactly as
// drawn (682 D14 names "the shelf run's answer with its Undo" a new part):
// the done pair, a row with the sentence and Undo beside it. One component,
// because 682 D14 reuses it unchanged on the item's page, which T4 does not draw.
//
// `note` is { kind: 'done' | 'undone' | 'error', text }. The Undo shows only on
// 'done' and lasts as long as the answer: the next press, a change of tab,
// leaving the page (F3). A refused Undo answers in red, in the same place (F1).
export const SHELF_RUN_ANSWER = Object.freeze({
  done: { background: '#E1F5EE', color: '#085041' },
  error: { background: '#FFEBEE', color: '#A32D2D' },
});

export default function ShelfRunAnswer({ note, onUndo = null, busy = false, style = null }) {
  const { coarse } = useTier();
  if (!note) return null;
  const pair = note.kind === 'error' ? SHELF_RUN_ANSWER.error : SHELF_RUN_ANSWER.done;
  const text = note.kind === 'undone' ? UNDONE_LINE : note.text;
  const undoable = note.kind === 'done' && typeof onUndo === 'function';
  return (
    <div
      role="status"
      data-part="shelf-run-answer"
      style={{
        display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0 0',
        background: pair.background, color: pair.color, borderRadius: 8,
        padding: '8px 8px 8px 12px', fontSize: 13, lineHeight: 1.35,
        ...(style || {}),
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>{text}</span>
      {undoable && (
        <ActionButton
          onClick={() => onUndo(note)}
          busy={busy}
          busyLabel="Undoing…"
          aria-label={`${UNDO_LABEL}: ${text}`}
          data-part="shelf-run-undo"
          style={{
            flex: 'none', margin: 0, height: controlHeight(coarse, 'commit'), borderRadius: 8,
            padding: '0 12px', fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: 14,
            letterSpacing: '.5px', textTransform: 'uppercase', display: 'flex',
            alignItems: 'center', justifyContent: 'center', lineHeight: 1,
            background: '#FFFFFF', color: '#166128', border: '1px solid #166128',
            whiteSpace: 'nowrap', cursor: 'pointer',
          }}
        >
          {UNDO_LABEL}
        </ActionButton>
      )}
    </div>
  );
}
